import { createRouter, createWebHistory } from 'vue-router'

import store from "@/store";

import HomePage from "@/pages/HomePage.vue";
import Login from "@/pages/Login.vue";
import Users from "@/pages/authenticated/Users.vue";
// import Reports from "@/pages/authenticated/Reports.vue"; // TEMP: disabled until reports rework
import Whales from "@/pages/authenticated/Whales.vue";
import Photos from "@/pages/authenticated/Photos.vue";
import Sightings from "@/pages/authenticated/Sightings.vue";
import Dashboard from "@/pages/authenticated/Dashboard.vue";
import Quality from "@/pages/authenticated/Quality.vue";
// import PublicReportSubmission from "@/pages/PublicReportSubmission.vue"; // TEMP: disabled until reports rework
import PasswordReset from "@/pages/authenticated/PasswordReset.vue";
import ForgotPassword from "@/pages/ForgotPassword.vue";
import RegisterAccount from "@/pages/RegisterAccount.vue";
// import AccountDelete from "@/pages/AccountDelete";
// import AccountDeleteForm from "@/pages/AccountDeleteForm";
// import PrivacyPolicy from "@/pages/PrivacyPolicy";


const router = createRouter({
  history: createWebHistory(),
  routes: [
    // { name: "publicReportSubmission", path: "/public_report", component: PublicReportSubmission }, // TEMP: disabled until reports rework
    { name: "homePage", path: "/home", component: HomePage },
    { name: "login", path: "/login", component: Login },
    { name: "users", path: "/users", component: Users },
    // { name: "reports", path: "/reports", component: Reports }, // TEMP: disabled until reports rework
    { name: "whales", path: "/whales", component: Whales },
    { name: "photos", path: "/photos", component: Photos },
    { name: "sightings", path: "/sightings", component: Sightings },
    { name: "dashboard", path: "/dashboard", component: Dashboard },
    { name: "quality", path: "/quality", component: Quality },
    { name: "reset", path: "/reset", component: PasswordReset },
    {
      name: "forgotPassword",
      path: "/forgotPassword",
      component: ForgotPassword,
    },
    { name: "register", path: "/register", component: RegisterAccount },
    // { name: "accountDelete", path: "/account-management", component: AccountDelete }, // We dont need these for the database
    // { name: "accountDeleteForm", path: "/account-management-form", component: AccountDeleteForm },
    // { name: "privacyPolicy", path: "/privacy-policy", component: PrivacyPolicy }, // TEMP removal
  ],
});

router.beforeEach((to, from, next) => {
  const publicPages = [
    "/login",
    "/reset",
    "/forgotPassword",
    "/public_report",
    "/register",
    "/home",
    "/account-management",
    "/account-management-form",
    "/privacy-policy",
  ];
  const authRequired = !publicPages.includes(to.path);
  const currentUser = store.getters["auth/isTokenSet"];
  const resetRequest = store.getters["auth/isPassTokenSet"];

  if (resetRequest) {
    return next("/reset");
  }

  if (authRequired && !currentUser) {
    return next("/home");
  }

  return next();
});

export default router;
